import { environment } from "src/environments/environment.local";
import { MaskitoOptions } from '@maskito/core';

export class Global {

  public static AnetTokenUrl = 'https://apitest.authorize.net/xml/v1/request.api';
  public static AnetPaymentUrl = 'https://test.authorize.net/payment/payment';
  public static LoginId = '887Nf8PpF8bZ';
  public static TransactionKey = '5y93u6r9NU3r42Rk';

  /* public static WreckerTowHeaderName = 'Authorization';
  public static WreckerTowHeaderValue = '1494175a-a628-4c94-a442-c7f2f005fc4e';
  public static MandatoryMessage = 'Please enter all mandatory fields';*/

  public static PPAAuthHeaderName = 'DLMSAuth';
  public static PPAAuthHeaderValue = 'admin';

  public static SaveMessage = 'Record Saved';
  public static UpdateMessage = 'Record Updated';
  public static NoImageUrl = 'assets/img/NoImage.jpg';
  public static LoaderImageUrl = 'assets/img/spinner.gif';

  public static DeleteMessage = 'Record Deleted';
  public static UniqueEmailFailed = 'Email Id must be Unique.It Seeems Another User is already registered with this Email Id';
  public static LoginSuccessMessage = ' Hello ';
  public static LoginFailureMessage = ' Invalid Credentials';
  public static PasswordUpdateMessage = 'Password Updated';
  public static DocumentUploadMessage = 'Document Uploaded';
  public static SaveErrorMessage = '';
  public static PasswordMismatchMessage = 'Password and Confirm Password do not Match';
  public static UniqueEmailUserFailed = 'Email Id must be Unique';
  public static AuthHeaderName = 'Authorization';
  public static AuthToken = '1494175a-a628-4c94-a442-c7f2f005fc4e';
  public static PoliceAuthHeaderName = 'DLMSAuth';
  public static PoliceAuthHeaderValue = 'swapna';
  public static DeleteConfirmationMessage = 'Are you sure want to delete?';
  public static AddCompanyConfirmationMessage = 'Would you like to add this company?';
  public static RemoveConfirmationMessage = 'Are you sure want to remove?';
  public static RemoveSelectedConfirmationMessage = 'Are you sure want to remove selected?';
  public static AuctionDatePresentMessage = 'Auction Date already present';
  public static AuctionDateRequiredtMessage = 'Auction Date required';
  public static RecordNotFoundMessage = 'Record not found';
  public static MoveConfirmationMessage = 'You are confirming the move of {0} vehicles scheduled for ' +
    '{1} to a new auction date {2}.';
  public static YearValidationMessage = 'End year should be same or greater than begin year';
  public static AuctionClosemsg = 'Auction Date closed successfully';
  public static MoveConfirmationMessageAlt = 'You are confirming the move of auction date {0} to new date {1}.';
  public static EMAIL_REGEX = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,3})$/;
  public static ZIP_REGEX = /^[0-9]{5}(?:-[0-9]{4})?$/;
  public static PHONE_REGEX = /\(\d{3}\) \d{3}-\d{4}/;
  public static NUMBER_REGEX = /^[0-9]+$/;
  public static phonemask: MaskitoOptions = { mask: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] };
  public static validThruMask: MaskitoOptions = { mask: [/\d/, /\d/, '/', /\d/, /\d/] };
  public static ALPHANEUMERIC_REGEX = /^[a-zA-Z0-9]+$/;
  public static ALPHA_REGEX = /^[\-\a-zA-Z\s]*$/;
  public static ALPHA_CHAR_REGEX = /^[ A-Za-z0-9_@.\#&+-]*$/;
  public static DECIMAL_REGEX = /^[0-9]\d{0,9}(\.\d{1,2})?%?$/;
  public static YEAR_REGX = /(19\d{2})|(20\d{2})/;
  public static UniqueEquipmentTagFailed = 'Equipment Tag must be Unique';
  public static UniqueLicensePlateFailed = 'License Plate must be Unique';
  public static UniqueVINFailed = 'VIN must be Unique';
  public static InvoiceGeneratedMessage = 'Invoice Generated';
  public static TowCompanyRegistrationMsg = 'Registration Successful.Now you can add Drivers and Equipments.';
  public static ServiceExistsMsg = 'Selected Service already exists in your Service List';
  public static BidderActiveMsg = 'Bidder already assigned in auction and can not be blocked';
  public static BidderAssignMsg = 'Bidder is blocked and can not be assigned'
  public static FullImagePath = environment.WebUrl + 'assets/loader.gif';
  public static UniqueContractIdFailed = 'Contract Id must be Unique';
  public static CancelledMessage = 'Record Cancelled';
  public static NobuyerMessage = 'You have selected to be buyers representative. Please add a company or select No';
  //public static GoogleMapAPIKey = '';
  public static SelectRecordMessage = 'Select at least one record';
  //public static GoogleMapAPIKey='AIzaSyCyzATQE2BYCfxvj40W_--m-z_pNjZRm7w'; 

  public static PageSize = 100;
  public static RecordsDeletedMessage = 'Records Deleted';
  public static ReversePaymentSuccessMessage = 'Payment Reversed';
  public static SetHeightTime = 1000;
  public static CloseDateConfirmationMessage = 'Are you sure want to close Auction Date?';
  public static PRICE_REGEX = /^(\$?\d{1,3}(,?\d{3})*)?(\.\d{1,2})?$/; //$99.99|99.99|99  
  public static DefaultLot = 6;
  //public static ReverseNoSaleSuccessMessage = 'No Sale Reversed';
  public static PRICE_REGEXN = /^(-?\$?\d{1,3}(,?\d{3})*)?(\.\d{1,2})?$/; //-$99.99|-99.99|-99 
  public static StorageFeeId = 2;
  public static QUANTITY_REGEX = /^([1-9][0-9]*)$/; //1|10|100 
  public static ReleasedMessage = 'Vehicle Released';
  public static StorageFeeCategoryId = 1;
  public static FILE_MAX_SIZE = 5242880;
  public static FILE_MAX_SIZE_MSG = "FILE SIZE EXCEEDED: Maximum file size is 5 MB. Please upload a smaller PDF or take a picture and upload.";
  public static MAX_FILE_COUNT = 5;
  public static MAX_FILE_COUNT_ERROR_MSG = "FILE COUNT EXCEEDED: Maximum 5 files per upload. Please upload extra files in next batch.";
  public static VIDEO_MAX_SIZE = 52428800;
  public static VIDEO_MAX_SIZE_MSG = "VIDEO SIZE EXCEEDED: Maximum video size is 50 MB. Please upload a smaller video.";
  public static hostedPaymentIFrameCommunicatorUrl = environment.WebUrl + "iFrameCommunicator.html";
  public static Mode: string = "testMode";
  public static NotificationBidderOnCreditCard: string = "Once a bid is placed, it cannot be canceled. If you are the winning bid on a vehicle, payment will be processed immediately. If payment fails, you maybe banned from bidding on future auctions.";
  public static NotificationBidForHPD: string = 'If you are interesting in bidding for the Houston Police Department Seller Vehicles, Please complete setting up the profile';
  //public static NotificationWireTransfer: string = 'Houston Police Department auctions payments to made through wire transfer after the auction ends the same business day before 5 pm central standard time.';
  public static NotificationWireTransfer: string ='';
}
